// extracted by mini-css-extract-plugin
module.exports = {"button":"LiveVideoStreamingButton_button__AaYZK","open":"LiveVideoStreamingButton_open__dbE0e","icon":"LiveVideoStreamingButton_icon__TzyOc"};